import React from 'react';
import { Link } from 'react-router-dom';
import './blog-post-card.css';

const BlogPostCard = ({ title, excerpt, url }) => {
  return (
    <div className="card-style">
      <h3 className="blog-post-title">{title}</h3>
      <p className="blog-post-excerpt">{excerpt}</p>
      <Link to={url} className="blog-post-link">Read More</Link>
    </div>
  );
};

export default BlogPostCard;